// REACT IMPORTS
import React, { useEffect } from "react";

// ICON IMPORTS
import DcdialLogo from "icons/DCDialLogo";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { previewDataGet } from "store/slices/paymentsSlice";
import { useParams } from "react-router-dom";
import { decode } from "utils/HelperFunctions";
import { RootState } from "store/store";

// PROPS TYPES
interface FooterProps {
  className?: string;
  _className?: string;
  style?: React.CSSProperties;
}

/* ------------------------------------- FOOTER ------------------------------------- */

const Footer = (props: FooterProps) => {
  const { className = "", style, _className = "" } = props;

  const { clusterId: cluster_id, id: actionId } = useParams();
  const clusterId = decode(cluster_id || "", true);
  const { companyDetails } = useAppSelector(
    (state: RootState) => state.payment
  );
  const dispatch = useAppDispatch();
  const onGetCompanyDetails = async () => {
    let slug = decode(actionId || "")?.split("_");
    let cluster_id = clusterId || slug[1] || "";
    try {
      let payload = {
        cluster_id: cluster_id,
      };
      await dispatch(previewDataGet(payload));
    } catch (error) {
      console.log("onGetCompanyDetails error =====", error);
    }
  };

  useEffect(() => {
    if (
      (!companyDetails || Object.keys(companyDetails).length === 0) &&
      ((clusterId && clusterId?.trim() !== "") ||
        (actionId && actionId?.trim() !== ""))
    ) {
      onGetCompanyDetails();
    }
  }, []);

  return (
    <div
      style={style}
      className={` w-full flex items-center justify-center lg:py-3.5 py-2 fixed bottom-0 bg-bgPrimary z-10 ${className}`}
    >
      <div className={`flex items-center ${_className}`}>
        <div className="flex items-center gap-2 md2:text-base xs:text-sm text-xs font-normal leading-normal">
          Powered by
          <DcdialLogo />
        </div>
        <div className="h-5 w-[1px] bg-strokePrimary xl:mx-4 mx-3" />
        <div className="flex xl:gap-5 gap-3.5 items-center">
          <a
            target="_blank"
            href={"https://www.dcdial.com/legal/terms-of-service"}
            className="md2:text-base xs:text-sm text-xs font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer"
          >
            Terms
          </a>
          <a
            target="_blank"
            href={"https://www.dcdial.com/legal/privacy-policy"}
            className="md2:text-base xs:text-sm text-xs font-normal leading-normal hover:!text-blue hover:!underline cursor-pointer"
          >
            Privacy
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
